import '../sass/frontend.scss';
import Sliders from './components/swiper-init';
import mouseEventsModal from './components/card-mouse-events';
import downScreen from './components/button-down';
import windowScrollHandlers from './components/window-scroll-handlers';
import mobileMenu from './components/mobile-menu';
import goToTop from './components/go-to-top';
import initialRedirect from './components/redirect-thanks-page';
import Popup from './parts/popup-window';
function ready() {
    const popupInstance = new Popup();
    popupInstance.init();
    Sliders.initSwiperBanner();
    Sliders.initSwiperOptional();
    downScreen();
    mouseEventsModal();
    windowScrollHandlers();
    mobileMenu();
    goToTop();
    initialRedirect(var_from_php.thanks);
}
window.document.addEventListener('DOMContentLoaded', ready);
